<template>
  <el-drawer
    title="Edit Beneficiary"
    :visible.sync="showDrawer"
    :with-header="true"
    :before-close="handleClose"
    :size="drawerWidth"
  >
    <el-form
      label-position="top"
      :model="form"
      ref="form"
      :rules="rules"
      @submit.native.prevent="validateForm('form')"
      @keyup.enter.native="validateForm('form')"
      class="w-full h-screen px-6"
    >
      <el-form-item label="Bank Name" prop="bankName">
        <el-input v-model="form.bankName" prefix-icon="el-icon-search" readonly>
        </el-input>
      </el-form-item>

      <div class="flex items-center gap-4">
        <el-form-item label="Account No" class="w-1/2" prop="accountNumber">
          <el-input v-model.trim="form.accountNumber" readonly></el-input>
        </el-form-item>

        <el-form-item label="Account Name" class="w-1/2" prop="accountName">
          <el-input v-model="form.accountName" readonly></el-input>
        </el-form-item>
      </div>

      <el-form-item label="Enter Amount" prop="amount">
        <el-input v-model.trim="form.amount">
          <i
            slot="prefix"
            class="font-normal text-black-10 h-full inline-flex items-center not-italic pl-3"
          >
            {{ formattedCurrency }}
          </i>
        </el-input>
      </el-form-item>

      <button
        type="submit"
        class="mt-10 text-white bg-primary w-full py-4 text-sm font-normal rounded-lg"
      >
        Save
      </button>
    </el-form>
  </el-drawer>
</template>

<script>
import breakpoints from '@/utils/breakpoints.js'
import bulkPayout from '@/mixins/bulkPayout'
import { ParseAmount, ValidateInput } from '@/utils/helpers.js'

export default {
  mixins: [bulkPayout],
  props: {
    showDrawer: {
      type: Boolean,
      default: false,
      required: true
    },
    details: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      form: {
        bankName: '',
        accountNumber: '',
        accountName: '',
        amount: ''
      },
      rules: {
        amount: [
          {
            required: true,
            message: 'Kindly enter an amount',
            trigger: ['blur', 'change']
          }
        ],
        bankName: [
          {
            message: 'Kindly enter a bank name',
            trigger: ['blur', 'change']
          },
          {
            validator: ValidateInput,
            trigger: ['blur', 'change']
          }
        ],
        accountName: [
          {
            message: 'Kindly enter an account name',
            trigger: ['blur', 'change']
          },
          {
            validator: ValidateInput,
            trigger: ['blur', 'change']
          }
        ]
      }
    }
  },
  computed: {
    drawerWidth () {
      return breakpoints.lgAndUp ? '33%' : breakpoints.mdAndUp ? '70%' : '90%'
    },
    selectedBeneficiaries () {
      return this.$store.state.bulkPayout.selectedBeneficiaries || []
    }
  },
  methods: {
    handleClose () {
      this.$emit('closeDrawer')
    },
    prefillForm () {
      this.form = {
        bankName: this.details.details.bankDetails.bankName || '',
        accountNumber: this.details.details.bankDetails.accountNumber || '',
        accountName: this.details.details.bankDetails.accountName || '',
        amount: this.details.amount || ''
      }
    },
    updateAmount () {
      const formattedAmount = this.form.amount.replace(/,/g, '')
      const updatedDetails = {
        ...this.details,
        amount: parseFloat(formattedAmount)
      }
      const filteredBeneficiaries = this.selectedBeneficiaries.filter(
        (beneficiary) => beneficiary.id !== this.details.id
      )
      const updatedBeneficiaries = [updatedDetails, ...filteredBeneficiaries]
      this.$store.dispatch(
        'bulkPayout/removeSelectedBeneficiaries',
        updatedBeneficiaries
      )

      this.handleClose()
    },
    validateForm (form) {
      this.$refs[form].validate((valid) => {
        if (valid) {
          this.updateAmount()
        } else {
          this.$notify.error({
            title: 'Invalid input',
            message: 'Please fill the input correctly',
            position: 'top-right'
          })
        }
      })
    }
  },
  watch: {
    'form.amount': function (newValue) {
      const result = ParseAmount(newValue)
      this.$nextTick(() => {
        this.form.amount = result
      })
    }
  },
  mounted () {
    this.prefillForm()
  }
}
</script>

<style scoped>
* >>> .el-drawer__header > :first-child {
  font-size: 0.9rem;
  color: var(--text-2);
  font-weight: 600;
}
* >>> .el-drawer__header {
  color: var(--text-4);
  font-size: 1.2rem;
  padding-bottom: 1rem;
  padding-top: 2rem;
  padding-left: 1.4rem;
  font-weight: 700;
  border-bottom: 1px solid var(--border-2);
}
* >>> .el-drawer {
  background: var(--background-9) !important;
}
</style>
